"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrap = exports.StyledButtonText = exports.StyledButtonLink = exports.StyledButton = exports.SIZES = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reset = require("../../utils/reset");

var _transitions = require("../../utils/transitions");

var _link = require("../../utils/link");

var _mediaQueries = _interopRequireDefault(require("../../utils/media-queries"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    max-width: 340px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SIZES = {
  small: 12,
  normal: 15,
  large: 21
};
exports.SIZES = SIZES;
var TYPOGRAPHY = {
  small: 16,
  normal: 18,
  large: 20
};

var calculateButtonPadding = function calculateButtonPadding(size, icon, hasLeftIcon, hasRightIcon, neighboringInGroup) {
  var spacing = SIZES[size];
  var typographyRelatedPadding = ((spacing * 2 - TYPOGRAPHY[size]) / 2).toFixed(1);
  var iconVisualCenterShift = 5 / 4;
  var iconPadding = (SIZES[size] / 2 * iconVisualCenterShift).toFixed(1); // Symetric padding around icon-only button for circle effect

  if (icon) {
    return "padding: ".concat(typographyRelatedPadding, "px;");
  }
  /* eslint-disable no-param-reassign, no-multi-assign */


  if (neighboringInGroup === 'both') {
    hasLeftIcon = hasRightIcon = true;
  } else if (neighboringInGroup === 'left') {
    hasLeftIcon = true;
  } else if (neighboringInGroup === 'right') {
    hasRightIcon = true;
  }

  return "\n    padding: ".concat(typographyRelatedPadding, "px;\n    padding-right: ").concat(hasRightIcon ? iconPadding : spacing, "px;\n    padding-left: ").concat(hasLeftIcon ? iconPadding : spacing, "px;\n  ");
};

var calculateTextPadding = function calculateTextPadding(size, hasLeftIcon, hasRightIcon) {
  var iconVisualCenterShift = 3 / 4;
  var iconPadding = (SIZES[size] / 2 * iconVisualCenterShift).toFixed(1);
  return "0 ".concat(hasRightIcon ? iconPadding : 0, "px 0 ").concat(hasLeftIcon ? iconPadding : 0, "px");
};

var calculateBorderRadius = function calculateBorderRadius(size, neighboringInGroup) {
  if (neighboringInGroup === 'both') {
    return '';
  } else if (neighboringInGroup === 'left') {
    return "border-radius: 0 ".concat(SIZES[size], "px ").concat(SIZES[size], "px 0;");
  } else if (neighboringInGroup === 'right') {
    return "border-radius: ".concat(SIZES[size], "px 0 0 ").concat(SIZES[size], "px;");
  }

  return "border-radius: 6px;";
};

var getButtonColor = function getButtonColor(props) {
  var theme = props.theme,
      variant = props.variant;

  if (variant === 'primary') {
    return theme.color.background;
  } else if (variant === 'secondary') {
    return theme.color.primaryDarkest;
  } else if (variant === 'link') {
    return (0, _link.getLinkColor)(props);
  }
};

var getButtonHoverColor = function getButtonHoverColor(props) {
  if (props.variant === 'link') {
    return (0, _link.getLinkHoverColor)(props);
  }
};

var getButtonBackground = function getButtonBackground(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;

  if (variant === 'primary') {
    return theme.color.primaryDark;
  } else if (variant === 'secondary') {
    return theme.color.miscLightest;
  }

  if (variant === 'link') {
    return 'transparent';
  }
};

var getButtonHoverBackground = function getButtonHoverBackground(_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;

  if (variant === 'primary') {
    return theme.color.primaryDarker;
  } else if (variant === 'secondary') {
    return theme.color.miscLighter;
  }

  if (variant === 'link') {
    return 'transparent';
  }
};

var getButtonActiveBackground = function getButtonActiveBackground(_ref3) {
  var theme = _ref3.theme,
      variant = _ref3.variant;

  if (variant === 'primary') {
    return theme.color.primaryDarkest;
  } else if (variant === 'secondary') {
    return theme.color.miscLight;
  }

  if (variant === 'link') {
    return 'transparent';
  }
};

var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "styled__StyledButton",
  componentId: "sc-1e85tz9-0"
})(["", " display:inline-block;color:", ";background:", ";font-size:", "px;line-height:", "px;", " transform:translateZ(0);", ";", ";", " transition-property:opacity,box-shadow;", " .icon-inherit-color{fill:", ";}&:hover,&:focus{", " ", "}&:active{", "}"], _reset.control, getButtonColor, getButtonBackground, function (_ref4) {
  var size = _ref4.size;
  return TYPOGRAPHY[size];
}, function (_ref5) {
  var size = _ref5.size;
  return TYPOGRAPHY[size];
}, _mediaQueries["default"].handheld(_templateObject()), function (_ref6) {
  var size = _ref6.size,
      neighboringInGroup = _ref6.neighboringInGroup;
  return calculateBorderRadius(size, neighboringInGroup);
}, function (_ref7) {
  var size = _ref7.size,
      isIconOnly = _ref7.isIconOnly,
      hasLeftIcon = _ref7.hasLeftIcon,
      hasRightIcon = _ref7.hasRightIcon,
      neighboringInGroup = _ref7.neighboringInGroup,
      variant = _ref7.variant;
  return calculateButtonPadding(size, isIconOnly, hasLeftIcon, hasRightIcon, neighboringInGroup, variant);
}, _transitions.switchTransition, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled ? 'opacity: .2;' : '';
}, getButtonColor, function (props) {
  return !props.disabled ? "\n        cursor: pointer;\n        background: ".concat(getButtonHoverBackground(props), ";\n        box-shadow: 0 0 0 1px ").concat(getButtonHoverBackground(props), ";\n\n        // Immediately change visual state on hover, mousedown and mouseup\n        // Transition only for mouseleave\n        transition: none;\n      ") : '';
}, function (props) {
  return !props.disabled && props.variant === 'link' && "color: ".concat(getButtonHoverColor(props), ";");
}, function (props) {
  return !props.disabled ? "\n        background: ".concat(getButtonActiveBackground(props), ";\n        box-shadow: none;\n      ") : '';
});

exports.StyledButton = StyledButton;
var StyledButtonLink = StyledButton.withComponent('a');
exports.StyledButtonLink = StyledButtonLink;

var StyledButtonText = _styledComponents["default"].span.withConfig({
  displayName: "styled__StyledButtonText",
  componentId: "sc-1e85tz9-1"
})(["display:inline-block;vertical-align:top;padding:", ";"], function (_ref9) {
  var size = _ref9.size,
      hasLeftIcon = _ref9.hasLeftIcon,
      hasRightIcon = _ref9.hasRightIcon;
  return calculateTextPadding(size, hasLeftIcon, hasRightIcon);
});

exports.StyledButtonText = StyledButtonText;

var IconWrap = _styledComponents["default"].span.withConfig({
  displayName: "styled__IconWrap",
  componentId: "sc-1e85tz9-2"
})(["display:inline-flex;vertical-align:top;justify-content:center;align-items:center;width:", "px;height:", "px;"], function (_ref10) {
  var size = _ref10.size;
  return TYPOGRAPHY[size];
}, function (_ref11) {
  var size = _ref11.size;
  return TYPOGRAPHY[size];
});

exports.IconWrap = IconWrap;